export class CompanyToken {
   CompanyItems = new Array<CompanyTokenItem>();
   ShowCompanySelection: boolean;
}

export class AuthUser {
   Email: string;
   IsVerifiedEmail: boolean;
   Name: string;
   Nickname: string;
   Picture: string;

   constructor(
      name: string,
      nickname: string,
      picture: string,
      email: string,
      isVerifiedEmail: boolean
   ) {
      this.Name = name;
      this.Nickname = nickname;
      this.Email = email?.toLowerCase();
      this.Picture = picture;
      this.IsVerifiedEmail = isVerifiedEmail;
   }
}

export class CompanyTokenItem {
   CompanyId: number;
   HasChildren: boolean;
   Name: string;
   ParentId: number;

   constructor(
      companyId: number,
      hasChildren: boolean,
      name: string,
      parentId?: number
   ) {
      this.CompanyId = companyId;
      this.HasChildren = hasChildren;
      this.Name = name;
      this.ParentId = parentId ? parentId : companyId;
   }
}

export enum AccessType {
   Create = 'Create',
   Read = 'Read',
   Update = 'Update',
}

export enum PermissionType {
   Child = 2,
   None = 3,
   Owner = 1,
}
